import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import actions from '../actions';
import Component from '../components/CompletionModal'
import { useHistory } from 'react-router-dom'

export default function Container() {
    const dispatch = useDispatch();

    const componentProps = {
        isOpen: useSelector(state => state.completionModal.isOpen),
        intl: {
            close: useSelector(state => state.intl.messages.modal.close),
            ...useSelector(state => state.intl.messages.completionModal)
        },
        courseTitle: useSelector(state => state.completionModal.courseTitle),
        launchParams: useSelector(state => state.completionModal.launchParams),
        orgId: useSelector(state => state.header.user.organizationId),
        studentId: useSelector(state => state.header.user.studentId),
        onClose: () => {
            dispatch(actions.closeModal())
        }
    }

    const history = useHistory();

    useEffect(() => {
        // Detects navigate back button clicked in browser and closes feedback modal if open  
        return () => {
            if (history.action === "POP") {
                dispatch(actions.closeModal())
            }
        }
    }, [])

    return (
        <Component {...componentProps} />
    )
}